module.exports = __webpack_public_path__ + "assets/img/RSPCA-Pet-Insurance-Pillar-Page-Resource-w960.a251b378.jpg";